import { Box, Grid, Typography, capitalize } from "@mui/material";

import { Template } from "features/Influencer/ContactList/schema";

interface Props {
  template: Template;
  index: number;
}

const TemplateChip = ({ template, index }: Props) => {
  return (
    <Box key={template.id}>
      <Grid container justifyContent={"space-between"}>
        <Grid item xs>
          <Box sx={{}} key={template.id}>
            {(index === 0 || index === 1) && (
              <Typography
                variant="caption"
                sx={{ color: "text.secondary", mr: 1 }}
              >
                {capitalize(template?.contentType)}
              </Typography>
            )}
            <Typography
              noWrap
              sx={{
                textOverflow: "ellipsis",
                fontSize: 16,
              }}
            >
              {template?.name}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TemplateChip;
